// Crayon (LOOKS.md Part 8 and 9): drawn by hand, on paper. Everything here is
// from its artboard, docs/design/mockups/looks/Crayon.dc.html and
// H2H-Crayon.dc.html.

import { defineLook } from '../define';
import { CrayonCup } from './art';
import { CrayonDefs } from './defs';
import { CRAYON_ICONS } from './icons';
import './look.css';

// Paper, and the crayon box: the artboard's position colors.
const PAPER = {
  'bg-canvas': '#fbf7ee',
  'bg-surface': '#fdfbf6',
  'bg-raised': '#fffdf8',
  'bg-sunken': '#f3ecdc',
  'border-subtle': '#cfc4b1',
  'border-strong': '#2b2b2b',
  'ink-primary': '#2b2b2b',
  'ink-secondary': '#57504a',
  'ink-muted': '#857b70',
  live: '#c21f35',
  'pos-qb': '#d7263d',
  'pos-rb': '#2a9d4b',
  'pos-wr': '#1b6ca8',
  'pos-te': '#f28c28',
  'pos-k': '#7b4bb7',
  'pos-dst': '#5c5c5c',
  'pos-dl': '#b4462b',
  'pos-lb': '#5b7a1c',
  'pos-db': '#14798a',
};

export default defineLook({
  id: 'crayon',
  label: 'Crayon',
  blurb: 'Hand-drawn on paper.',
  order: 1,
  // Paper is light, so it is light in either Mode (B-300). Its chalkboard in
  // dark did not look good enough to keep.
  mode: 'light',
  grounds: { light: PAPER, dark: PAPER },
  fonts: () =>
    Promise.all([
      import('@fontsource/fredoka/400.css'),
      import('@fontsource/fredoka/500.css'),
      import('@fontsource/fredoka/600.css'),
      import('@fontsource/fredoka/700.css'),
      import('@fontsource/gochi-hand/400.css'),
      import('@fontsource/patrick-hand/400.css'),
    ]),
  icons: CRAYON_ICONS,
  cup: CrayonCup,
  defs: CrayonDefs,
});
